export default {
  name: 'location-description',

  props: {
    title: {
      required: true,
      type: String
    },
    description: {
      required: false,
      type: String
    },
    itemprop: {
      default: true,
      required: false,
      type: Boolean
    }
  },

  data() {
    return {
      isClosed: true,
      showMoreText: false,
      buttonText: null
    }
  },

  mounted() {
    this.buttonText = this.$t('common.seemore')
  },

  methods: {
    seeMore() {
      this.showMoreText = !this.showMoreText
      if (this.showMoreText === false) {
        this.isClosed = true
        this.buttonText = this.$t('common.seemore')
      } else {
        this.isClosed = false
        this.buttonText = this.$t('common.seeless')
      }
    }
  }

}
